import { create } from "zustand";
import { persist } from "zustand/middleware";

const useAppSession = create(
  persist(
    (set, get) => ({
      token: null,
      clientId: null,
      sessionId: null,
      roles: [],
      locale: "pt",

      setToken: (token) => set({ token }),
      setClientId: (clientId) => set({ clientId }),
      setSessionId: (sessionId) => set({ sessionId }),
      setRoles: (roles) => set({ roles }),
      setLocale: (locale) => set({ locale }),


      logout: () => {
        set({
          token: null,
          clientId: null,
          sessionId: null,
          roles: [],
        });
        localStorage.removeItem("app-session");
        localStorage.removeItem("token");
        window.location.href = "/login";
      },


      clearSession: () => {
        get().logout();
      },


      login: ({ token, clientId, roles }) => {
        set({
          token,
          clientId,
          roles: Array.isArray(roles) ? roles.map(r => r.toUpperCase()) : ["CHAT"],
        });
        localStorage.setItem("token", token);
        window.location.href = "/";
      },
    }),
    {
      name: "app-session",
      getStorage: () => localStorage,
    }
  )
);

export default useAppSession;
